import { bridge, isNotNil } from 'shared/src/utils';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useRetainedEffect } from 'shared/src/hooks/retainedState';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import type { SimilarGoodsItem } from 'shared/src/api/goodsService/getSimilarGoods/types';
import { buildGoodsAnalyticsParams } from '../utils/buildGoodsAnalyticsParams';

export const useLogDisplayRelatedGoods = (params: {
  isSuccess: boolean;
  isLoading: boolean;
  listId: string;
  listParams: string;
  focused: boolean;
  targetList: SimilarGoodsItem[];
}) => {
  const goodsSno = useGoodsSno();

  useRetainedEffect(
    'view-display-related-goods',
    () => {
      if (!(params.focused && params.isSuccess && params.targetList.length > 0))
        return false;

      bridge.logAnalyticsEvent({
        channel: ['ablylog'],
        name: 'VIEW_DISPLAY_RELATED_GOODS',
        analytics: {
          GOODS_SNO: goodsSno,
        },
      });

      params.targetList.forEach((item, index) => {
        bridge.logAnalyticsEvent({
          name: 'DISPLAY_GOODS',
          channel: ['firebase', 'amplitude', 'ablylog', 'facebook'],
          analytics: {
            SCREEN: 'GOODS_DETAIL',
            LIST_ID: params.listId,
            LIST_INDEX: index,
            LIST_PARAMS: params.listParams,
            ...buildGoodsAnalyticsParams(item),
            ...item.logging.analytics,
          },
          ably_only_log: { ...item.logging.ably_only_log },
        });
        if (isNotNil(item.ad)) {
          bridge.logAdEvent({ action: AdAction.DISPLAY, ad: item.ad });
        }
      });
    },
    [params, goodsSno],
  );
};
